import React from 'react'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'
import MediaQuery from 'react-responsive'

const TitleAnnouncer = (props) => {
  const [title, setTitle] = React.useState('')
  const titleRef = React.createRef()
  const { pathname } = useLocation()
  const onHelmetChange = ({ title }) => setTitle(title)

  React.useEffect(() => {
    if (titleRef.current) titleRef.current.focus()
  }, [pathname])

  return (
    <MediaQuery minDeviceWidth={1025}>
      <div className='hide-absolute'>
        <p
          role='status'
          aria-live='assertive'
          aria-atomic='true'
          ref={titleRef}
          className='hide-absolute TitleAnnouncer'
        />

        <Helmet onChangeClientState={onHelmetChange} />
      </div>
    </MediaQuery>
  )
}

export default TitleAnnouncer
